// components/tracking/StatsCards.jsx
import React from "react";
import { Truck, Navigation, AlertTriangle, HelpCircle } from "lucide-react";

const StatsCards = ({ vehicles }) => {
  const stats = [
    {
      label: "Total Vehicles",
      value: vehicles.length,
      icon: Truck,
      color: "blue",
      gradient: "from-blue-500 to-cyan-500",
    },
    {
      label: "Active",
      value: vehicles.filter((v) => v.status === "active").length,
      icon: Navigation,
      color: "green",
      gradient: "from-green-500 to-emerald-500",
    },
    {
      label: "Inactive",
      value: vehicles.filter((v) => v.status === "inactive").length,
      icon: AlertTriangle,
      color: "red",
      gradient: "from-red-500 to-rose-500",
    },
    {
      label: "Unknown",
      value: vehicles.filter((v) => v.status === "unknown").length,
      icon: HelpCircle,
      color: "gray",
      gradient: "from-gray-500 to-slate-500",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
      {stats.map((stat, index) => {
        const IconComponent = stat.icon;
        return (
          <div
            key={index}
            className="group relative bg-white rounded-2xl p-6 border border-gray-200 hover:border-transparent hover:shadow-xl transition-all duration-300 overflow-hidden"
            style={{
              animationDelay: `${index * 100}ms`,
              animation: "slideUp 0.5s ease-out forwards",
            }}
          >
            {/* Gradient Background on Hover */}
            <div
              className={`absolute inset-0 bg-gradient-to-br ${stat.gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-300`}
            ></div>

            <div className="relative flex items-center justify-between">
              <div>
                <p className="text-3xl font-bold text-gray-900 mb-1 group-hover:scale-110 transition-transform duration-300 inline-block">
                  {stat.value}
                </p>
                <p className="text-sm font-medium text-gray-600">
                  {stat.label}
                </p>
              </div>
              <div
                className={`relative p-3 rounded-xl bg-gradient-to-br ${stat.gradient} shadow-lg group-hover:scale-110 group-hover:rotate-6 transition-all duration-300`}
              >
                <IconComponent className="w-6 h-6 text-white" />
                <div
                  className={`absolute inset-0 bg-gradient-to-br ${stat.gradient} rounded-xl blur opacity-50 group-hover:opacity-75 transition-opacity duration-300`}
                ></div>
              </div>
            </div>

            {/* Progress Bar */}
            <div className="mt-4 h-1 bg-gray-100 rounded-full overflow-hidden">
              <div
                className={`h-full bg-gradient-to-r ${stat.gradient} transition-all duration-1000 ease-out`}
                style={{
                  width:
                    vehicles.length > 0
                      ? `${(stat.value / vehicles.length) * 100}%`
                      : "0%",
                }}
              ></div>
            </div>
          </div>
        );
      })}

      <style jsx>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default StatsCards;
